<template>
  <perfect-scrollbar>
<div style="max-height: 400px;">
  <ul>
    <li v-for="(item, index) in notifications" :key="index">
      <div class="notification-item">
        <img
          height="33px"
          class="notification-icon"
          src="@/assets/img/noti-icon.svg"
          alt="Icon"
        />
        <p class="notification-title">
          {{item.Title}}
        </p>
        <p class="notification-des truncate">
          {{item.Content}}
        </p>
        <p class="notification-time">{{ item.Time | moment("from", "now") }}</p>
      </div>
    </li>
  </ul>
  <infinite-loading spinner="bubbles" @infinite="fetchData">
    <div class="text-red" slot="no-more"></div>
    <div class="text-red" slot="no-results"></div>
  </infinite-loading>
  </div>
  </perfect-scrollbar>

</template>

<script>
import { mapState } from 'vuex'
import infiniteHandler from '@/mixins/infiniteScroll'
import InfiniteLoading from 'vue-infinite-loading'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  name: 'PersonalNotification',
  mixins: [infiniteHandler],
  components: {
    InfiniteLoading,
    PerfectScrollbar
  },
  computed: {
    ...mapState('unreadNotifications', {
      notifications: 'items'
    })
  },
  methods: {
    fetchData: function ($state) {
      this.infiniteHandler($state, 'unreadNotifications', 'Notification/GetNotification', { isRead: false })
    }
  }
}
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
